module.exports = __webpack_public_path__ + "static/media/icon-chevron-left.dcd74f49.svg";